// Modal opener for people-cards.liquid
(function () {
  function qs(selector, context = document) {
    return context.querySelector(selector);
  }
  function qsa(selector, context = document) {
    return Array.from(context.querySelectorAll(selector));
  }

  // Find all people-cards
  document.addEventListener("DOMContentLoaded", function () {
    // Use a unique class for each section instance
    qsa(".meet-the-team").forEach((section) => {
      let lastFocusedElement = null;
      let focusTrap = null;

      //   Open modal
      function openModal(modal, trigger) {
        if (!modal) return;
        // Store focused element (usually modal trigger here) so we can move back to it on close
        lastFocusedElement = trigger;
        modal.hidden = false;

        // Set z-index for .team-cards when modal is open
        const teamCards = qs(".team-cards", section);
        if (teamCards) teamCards.style.zIndex = "9999999";

        document.body.classList.add("overflow-hidden");
        // Focus trap within modal
        trapFocusModal(modal);
        // Focus the close button
        const closeBtn = qs(".team-modal__close", modal);
        if (closeBtn) closeBtn.focus();
        // Update aria attributes
        modal.setAttribute("aria-hidden", "false");
        trigger.setAttribute("aria-expanded", "true");
      }

      //   Close Modal
      function closeModal(modal) {
        if (!modal) return;
        modal.hidden = true;
        modal.setAttribute("aria-hidden", "true");
        // Reset z-index for .team-cards when modal is closed
        const teamCards = qs(".team-cards", section);
        if (teamCards) teamCards.style.zIndex = "1";
        document.body.classList.remove("overflow-hidden");
        // Remove focus trap
        releaseFocusTrap();
        // Return focus to the modal opener
        if (lastFocusedElement) {
          lastFocusedElement.focus();
          lastFocusedElement.setAttribute("aria-expanded", "false");
        }
      }

      //   Trap focus within the modal
      function trapFocusModal(modal) {
        releaseFocusTrap();
        const focusableSelectors = [
          "a[href]",
          "area[href]",
          "input:not([disabled])",
          "select:not([disabled])",
          "textarea:not([disabled])",
          "button:not([disabled])",
          "iframe",
          "object",
          "embed",
          '[tabindex]:not([tabindex="-1"]), [contenteditable]',
        ];
        const focusableEls = qsa(focusableSelectors.join(","), modal).filter(
          (el) => el.offsetParent !== null,
        );
        if (!focusableEls.length) return;
        function handleTrap(e) {
          if (e.key === "Tab") {
            const first = focusableEls[0];
            const last = focusableEls[focusableEls.length - 1];
            if (e.shiftKey) {
              if (document.activeElement === first) {
                e.preventDefault();
                last.focus();
              }
            } else {
              if (document.activeElement === last) {
                e.preventDefault();
                first.focus();
              }
            }
          } else if (e.key === "Escape") {
            closeModal(modal);
          }
        }
        modal.addEventListener("keydown", handleTrap);
        focusTrap = () => modal.removeEventListener("keydown", handleTrap);
      }
      function releaseFocusTrap() {
        if (focusTrap) focusTrap();
        focusTrap = null;
      }

      // Modal open/close event listeners
      qsa(".team-card-modal-trigger", section).forEach((trigger) => {
        const modalId = trigger.getAttribute("data-modal-id");
        const modal =
          qs(`#${modalId}`, section) || document.getElementById(modalId);
        if (!modal) return;
        trigger.addEventListener("click", function (e) {
          // Open matching modal
          openModal(modal, trigger);
        });
        // Accessibility aria update
        trigger.setAttribute("aria-expanded", "false");
      });
      qsa(".team-modal", section).forEach((modal) => {
        // Overlay click closes modal
        qs(".team-modal__overlay", modal)?.addEventListener("click", () =>
          closeModal(modal),
        );
        // Close button closes modal
        qs(".team-modal__close", modal)?.addEventListener("click", () =>
          closeModal(modal),
        );
        // Prevent click inside modal content from closing
        qs(".team-modal__content", modal)?.addEventListener("click", (e) =>
          e.stopPropagation(),
        );
      });
    });
  });
})();
